import { render, staticRenderFns } from "./QueueStep5.vue?vue&type=template&id=23d25641&scoped=true&"
import script from "./QueueStep5.vue?vue&type=script&lang=js&"
export * from "./QueueStep5.vue?vue&type=script&lang=js&"
import style0 from "./QueueStep5.vue?vue&type=style&index=0&id=23d25641&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d25641",
  null
  
)

export default component.exports